module.exports = __webpack_public_path__ + "static/media/default-profile.66150e7e.png";